"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
var isTokensValid = function isTokensValid(tokenData) {
  // do some basic validation on the tokenData
  if (_lodash.default.isNil(tokenData) || _lodash.default.isNil(tokenData.accessToken) || _lodash.default.isNil(tokenData.idToken)) {
    return false;
  }
  var accessToken = tokenData.accessToken,
    idToken = tokenData.idToken; // see if we can decode the tokens without throwing

  try {
    (0, _jwtDecode.default)(accessToken);
    (0, _jwtDecode.default)(idToken);
  } catch (err) {
    // if we throw while decoding return false
    return false;
  }
  return true;
};
var _default = isTokensValid;
exports.default = _default;